import { JobType } from "../clients/generic_recon_client/api";

/**
 * Mapping of recon type query parameters to their breadcrumb display labels
 * Used in the Navbar component to show appropriate breadcrumbs for /recon routes
 */
export const RECON_BREADCRUMBS: Record<string, string> = {
  pg_recon: "PG Reconciliations",
  bank_recon: "Bank Reconciliations",
  ledger_recon: "Ledger Reconciliations",
  tds_recon: "TDS Reconciliations",
};

/** Query param for recon view on single page: dashboard | records. */
export const RECON_VIEW_PARAM = "view";
export const RECON_VIEW_DASHBOARD = "dashboard";
export const RECON_VIEW_RECORDS = "records";

/**
 * Whether the current view is dashboard (single recon page with view=dashboard).
 */
export const isReconDashboardView = (
  query: Record<string, string | string[] | undefined>
): boolean => query[RECON_VIEW_PARAM] === RECON_VIEW_DASHBOARD;

/**
 * Dashboard link for recon (same page, view=dashboard). Preserves type.
 */
export const getReconDashboardHref = (
  type?: string | string[]
): string =>
  `/recon?type=${encodeURIComponent(typeof type === "string" ? type : JobType.LedgerRecon)}&${RECON_VIEW_PARAM}=${RECON_VIEW_DASHBOARD}`;

/**
 * Records link for recon (same page, no view or view=records). Preserves type.
 */
export const getReconRecordsHref = (type?: string | string[]): string => {
  const t = typeof type === "string" ? type : JobType.LedgerRecon;
  return `/recon?type=${encodeURIComponent(t)}`;
};

/** Label shown in breadcrumb when on Ledger Recon Dashboard view. */
export const LEDGER_RECON_DASHBOARD_LABEL = "Ledger Recon Dashboard";

/**
 * Get breadcrumb label for a recon type
 * @param type - The recon type query parameter value
 * @param isDashboard - When true and type is ledger_recon, returns "Ledger Recon Dashboard"; otherwise "Ledger Reconciliations"
 * @returns The formatted breadcrumb label, or the formatted type if not found
 */
export const getReconBreadcrumbLabel = (
  type: string | string[] | undefined,
  isDashboard?: boolean
): string => {
  if (!type || Array.isArray(type)) {
    return "Recon";
  }

  if (type === "ledger_recon" && isDashboard) {
    return LEDGER_RECON_DASHBOARD_LABEL;
  }

  return RECON_BREADCRUMBS[type] || type;
};
